import React, { Component } from 'react';
import {
  withRouter
} from "react-router-dom";

// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import { getCategories, getAvailableMonthByCategory, getCoursesByCategoryAndMonth, getInstructorByCourseName, searchCourse, enrollCourse } from '../../redux/action';

import './Landing.css'; 
import Header from '../common/Header';
import Footer from '../common/Footer';
import logo from '../../images/logo.png';
import banner from '../../images/banner.jpeg';

// import logo from '../../images/logo.png';

import { RESOURCE_URL } from "../../constant/Constant";
import { getValue, getLocalLocale } from "../../constant/Locale";

import BannerAnim from 'rc-banner-anim';
import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';
import 'rc-banner-anim/assets/index.css';

import ScrollMenu from 'react-horizontal-scrolling-menu';

import courseIcon from '../../images/courseIcon.png';
import activeCourseIcon from '../../images/activeCourseIcon.png';

import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputBase from '@material-ui/core/InputBase';
import MenuItem from '@material-ui/core/MenuItem';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

import { createStyles, makeStyles, withStyles, Theme } from '@material-ui/core/styles';

const { Element } = BannerAnim;
const BgElement = Element.BgElement;

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);


const TopMenuItem = ({text, selected}) => {
  return <div
    className={`menu-item ${selected ? 'active' : ''}`}
    >


      <img src={( selected ) ? activeCourseIcon : courseIcon} className="courseIcon"/>
      <p>{text}</p></div>;
};

const Arrow = ({ text, className }) => {
  return (
    <div
      className={className}
    >{text}</div>
  );
};

const ArrowLeft = Arrow({ text: '<', className: 'arrow-prev' });
const ArrowRight = Arrow({ text: '>', className: 'arrow-next' });


const selected = 'item1';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

class Landing extends Component {

  constructor(props, context) {

    super(props, context);
    this.state = {
      shouldOpenDialog: false,
      shouldShowRegForm: false,
      shouldShowSuccessPage: false
    };

    this.handleMonthChange = this.handleMonthChange.bind(this);
    this.handleCourseChange = this.handleCourseChange.bind(this);
    this.handleInstructorChange = this.handleInstructorChange.bind(this);
    this.nameChange = this.nameChange.bind(this);
    this.mobileChange = this.mobileChange.bind(this);
    this.emailChange = this.emailChange.bind(this);

  }

  componentWillMount() {

  }

  

  componentDidMount() { 

    getCategories().then(response => {
      console.log(response.data);
      this.setState({ categories: response.data });
    });
  }

  onSelect = key => {
    this.setState({ selected: key });

    getAvailableMonthByCategory(key).then(response => {
      console.log(response.data);
      this.setState({ 
         months: response.data, 
         selectedMonth: 0, 
         selectedYear: 0, 
         selectedInstructor: '', 
         courseName: '', 
         courses: [], 
         instructors: [] });
    });


  }

  handleClose() {
    this.setState({ shouldOpenDialog: false, shouldShowRegForm: false, shouldShowSuccessPage: false });

  }

  categoriesMenu() {
    let categories = [];

    if( this.state.categories ) {
      categories = this.state.categories.map(ele=> {
        return <TopMenuItem text={ele.name} key={ele.id} selected={selected} />;
      });
    }

    return categories;
     
  }

  monthsMenu() {
    let months = [];

    if( this.state.months ) {
      months = this.state.months.map(ele=> {
         return <MenuItem value={ele.Month + "/" + ele.Year}>{ele.Month}/{ele.Year}</MenuItem>
      });
    }

    return months;
  }

  coursesMenu() {
    let courses = [];

    if( this.state.courses ) {
      courses = this.state.courses.map(ele=> {
         return <MenuItem value={ele.name}>{ele.name}</MenuItem>
      });
    }

    return courses;
  }

  instructorsMenu() {
    let instructors = [];

    if( this.state.instructors ) {

      instructors = this.state.instructors.map(ele=> {
        console.log(ele.id);
         return <MenuItem key={ele.id} value={ele.id}>{ele.name}</MenuItem>
      });
    }

    return instructors;
  }

  handleMonthChange(event) {
    // getCoursesByCategoryAndMonth()
    let month = event.target.value.split("/")[0];
    let year = event.target.value.split("/")[1];

    let categoryId = this.state.selected;

    this.setState({ selectedMonth: month, selectedYear: year });

    getCoursesByCategoryAndMonth(categoryId, month, year).then( response => {
      this.setState({ courses: response.data });
    });
  }

  handleCourseChange(event) {
    this.setState({ courseName: event.target.value });
    getInstructorByCourseName(event.target.value).then( response => {
      this.setState({ instructors: response.data });
    });
  }

  handleInstructorChange(event) {
    this.setState({ selectedInstructor: event.target.value });
  }

  handleSearchCourse() {
    searchCourse(this.state.selectedInstructor, this.state.selectedMonth, this.state.selectedYear, this.state.courseName).then( response => {
      console.log( response.data );
      this.setState({ availableCourses: response.data, shouldOpenDialog: true });
    });
  }

  handleReserve(ele) {

    this.setState({ shouldShowRegForm: true, courseToEnroll: ele });
  }

  handleEnroll() {

    // alert(this.state.courseToEnroll.cid);
    enrollCourse(this.state.name, this.state.email, this.state.mobile, this.state.courseToEnroll.cid ).then( response => {
      console.log( response.data );
      this.setState({ shouldShowSuccessPage: true });
      // this.setState({ courses: response.data, shouldOpenDialog: true });
    });
  }

  handleCancel() {
    this.setState({ shouldShowRegForm: false }); 
  }

  nameChange(event) {
    this.setState({ name: event.target.value});
  }

  mobileChange(event) {
    this.setState({ mobile: event.target.value});
  }

  emailChange(event) {
    this.setState({ email: event.target.value});
  }

  pdfLink(ele) {

    if( ele.pdf && JSON.parse(ele.pdf).length > 0 ) {
      return (
        <div>
        PDF: <a href={"http://workshopcms.usoplanet.co/storage/" +  JSON.parse(ele.pdf)[0].download_link} target="_blank">Link</a>
        </div>
      );
    }
                  
  }

  loadSuccessPage() {
    return (
    <div className="courseInfo">
       <h2>Reserved Success !! </h2>

       <h4>{this.state.courseToEnroll.course_name}</h4>
       <p>{(this.state.courseToEnroll.course_description)}</p>
       <p>
         Date: {this.state.courseToEnroll.date} <br />
         Time: {this.state.courseToEnroll.start_time} - {this.state.courseToEnroll.end_time} <br />
         
         {this.pdfLink(this.state.courseToEnroll)}
          
       </p>
     </div>);
  }

  loadForm() {

    return (
      <div className="customerForm">

         <div className="courseInfo">
           <h4>{this.state.courseToEnroll.course_name}</h4>
           <p>{(this.state.courseToEnroll.course_description)}</p>
           <p>
             Date: {this.state.courseToEnroll.date} <br />
             Time: {this.state.courseToEnroll.start_time} - {this.state.courseToEnroll.end_time} <br />
             
             {this.pdfLink(this.state.courseToEnroll)}
              
           </p>
         </div>


        <p><label>Name: </label>
        <input type="text" onChange={ this.nameChange}/> </p>
        <p><label>Mobile: </label>
        <input type="text" onChange={ this.mobileChange}/> </p>
        <p><label>Email: </label>
        <input type="text" onChange={ this.emailChange}/> </p>
        <p className="enrollArea">
          <button onClick={() => this.handleEnroll()}>Enroll</button>
          <button onClick={() => this.handleCancel()}>Cancel</button>
        </p>
      </div> 

    );

    
  }

  loadCourseResults() {

    let courses = [];

    if( this.state.availableCourses ) {

      courses = this.state.availableCourses.map(ele=> {
        console.log(ele);
         return (

           <div className="course">
             <div className="courseThumbnail">
               <img src={"http://workshopcms.usoplanet.co/storage/" + ele.profilePic} className="profilePic" />
               <img src={"http://workshopcms.usoplanet.co/storage/" + ele.thumbnail} className="courseBg" />
             </div>
             <div className="courseInfo">
               <h4>{ele.course_name}</h4>
               <p>{(ele.course_description) ? ele.course_description.substring(0, 50) + "..." : ""}</p>

               <p>
                 Date: {ele.date} <br />
                 Time: {ele.start_time} - {ele.end_time} <br />
                 Quota: {ele.quota} <br />
                 

                 
                 {this.pdfLink(ele)}

                  
               </p>



               <button onClick={() => this.handleReserve(ele)}>Reserve now</button>
             </div>
             
           </div>

         );
      });
    }

    return courses;
  }

  render() {
    // const classes = useStyles();
    const menu = this.menuItems;
    return (

      <div className="landingContainer">

        <Header />

        <div className="categoryBox">

          <ScrollMenu
            data={this.categoriesMenu()}
            // arrowLeft={ArrowLeft}
            // arrowRight={ArrowRight}
            selected={selected}
            onSelect={this.onSelect}
            hideArrows={true}
            translate={1}
          />
        </div>

        <Dialog onClose={this.state.shouldOpenDialog} aria-labelledby="customized-dialog-title" open={this.state.shouldOpenDialog}>
           <DialogTitle id="customized-dialog-title" onClose={() => this.handleClose()}>
          </DialogTitle>
          <DialogContent>
            <Typography gutterBottom>


              { (this.state.shouldShowSuccessPage) ? this.loadSuccessPage() :  
                (this.state.shouldShowRegForm) ? this.loadForm() :  
                (this.state.shouldOpenDialog) ? this.loadCourseResults() : "" }

              {/*{ (!this.state.shouldShowRegForm) ? this.loadCourseResults() : "" } 

              { (this.state.shouldShowRegForm) ? this.loadForm() : "" }*/}
            </Typography>
           
          </DialogContent>
        </Dialog>

        <div className="registerBox">

          <FormControl className={"formControl"}>
            {/*<InputLabel id="demo-customized-select-label">Chosen Course</InputLabel>*/}
            <InputLabel id="demo-controlled-open-select-label">Pick the available month</InputLabel>
            <Select
              labelId="demo-customized-select-label"
              id="demo-customized-select"
              value={ this.state.selectedMonth > 0 ? this.state.selectedMonth + "/" + this.state.selectedYear : '' }

              onChange={this.handleMonthChange}
              input={<BootstrapInput />}
            >
              
              {this.monthsMenu()}
            </Select>
          </FormControl>

          <FormControl className={"formControl"}>
            {/*<InputLabel id="demo-customized-select-label">Chosen Course</InputLabel>*/}
            <InputLabel id="demo-controlled-open-select-label">Pick the course</InputLabel>
            <Select
              labelId="demo-customized-select-label"
              id="demo-customized-select"
              value={this.state.courseName && this.state.courseName.length > 0 ? this.state.courseName : "" }
              onChange={this.handleCourseChange}
              input={<BootstrapInput />}
            >
              {this.coursesMenu()}
            </Select>
          </FormControl>

          <FormControl className={"formControl"}>
            {/*<InputLabel id="demo-customized-select-label">Chosen Course</InputLabel>*/}
            <InputLabel id="demo-controlled-open-select-label">Pick the instructor</InputLabel>
            <Select
              labelId="demo-customized-select-label"
              id="demo-customized-select"
              value={ this.state.selectedInstructor > 0 ? this.state.selectedInstructor : '' }
              onChange={this.handleInstructorChange}
              input={<BootstrapInput />}
            >
               {this.instructorsMenu()}
            </Select>
          </FormControl>

          <button className="enroll" onClick={() => this.handleSearchCourse()}>SEARCH</button>
        </div>
        

        {/*<Footer />*/}
      </div>
    );
  }


}

const mapStateToProps = (state) => {
  return {

  };
}

export default withRouter(connect(
    mapStateToProps,
    {  }
)(Landing));
